import { Panel } from '../components/ui';
import { PageHeader } from '../components/PageHeader';
import { useCurrentRoute } from '../shell/useCurrentRoute';

const TAG = /^([A-F]\d|M\d)\s(.+)$/;

/**
 * What a route renders before its screen exists. Honest by construction: it says what is
 * not built and names the task that will build it. Live routes render this inside the
 * LiveGate and under the LiveBanner, both applied by the shell.
 */
export default function PlaceholderPage() {
  const { route } = useCurrentRoute();
  if (!route) return null;
  const { node } = route;
  const live = route.env === 'live';
  const plan = node.plan && node.plan.length ? node.plan : ['To be defined'];

  return (
    <>
      <PageHeader title={node.label} />
      <Panel>
        <div className="px-5 py-9 text-center text-ink-2">
          <h2 className="m-0 mb-1.5 text-[15px] font-semibold text-ink">Not built yet</h2>
          <p className="mx-auto my-0 max-w-[52ch] text-[12.5px]">
            {live
              ? 'Live trading stays behind its own confirmation step and its own colour, so it can never be mistaken for paper. Nothing here routes an order until Milestone 3.'
              : 'This section is reserved. The work that will fill it:'}
          </p>
          <ol className="mx-auto mt-4 flex max-w-[520px] list-none flex-col gap-px p-0 text-left">
            {plan.map((item) => {
              const m = TAG.exec(item);
              return (
                <li
                  key={item}
                  className="flex gap-2.5 border border-border bg-raised px-3 py-2 text-[12.5px] text-ink first:rounded-t-panel last:rounded-b-panel"
                >
                  <b className="num w-7 flex-none text-accent-ink">{m ? m[1] : '·'}</b>
                  <span>{m ? m[2] : item}</span>
                </li>
              );
            })}
          </ol>
        </div>
      </Panel>
    </>
  );
}
